import ED from './bluestone/ED';
import GO from './bluestone/GO';
import OP from './bluestone/OP';
import TR from './bluestone/TR';
import COBALT_ED from './cobalt/ED';
import COBALT_GO from './cobalt/GO';
import COBALT_OP from './cobalt/OP';
import COBALT_TR from './cobalt/TR';
import DIAMOND_ED from './diamond/ED';
import DIAMOND_GO from './diamond/GO';
import DIAMOND_OP from './diamond/OP';
import DIAMOND_TR from './diamond/TR';

const themes = {
  ED,
  GO,
  OP,
  TR,
  COBALT_ED,
  COBALT_GO,
  COBALT_OP,
  COBALT_TR,
  DIAMOND_ED,
  DIAMOND_GO,
  DIAMOND_OP,
  DIAMOND_TR,
};

export { themes };
